<template>
  <v-layout>
    <div class="box">
      <div class="d-flex justify-space-between align-center mb-10 globo font-28">
        <img src="/globo_degrade.svg" alt="Globo Entregas" />
        <span>|</span>
        <span>Entregas</span>
      </div>
      <slot />
    </div>
  </v-layout>
</template>

<style lang="scss" scoped>
.box {
  position: absolute;
  left: 50%;
  max-width: 415px;
  text-align: center;
  top: 50%;
  transform: translate(-50%, -50%);
  width: calc(100% - 40px);
}

footer {
  bottom: 60px;
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
}
</style>
